import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'
import {
  DialogFeedbackComponent,
  PopoverConfirmComponent,
} from '@/views/components'
import useSnackbar from '@/hooks/ui/use-snackbar.hook'

import useDialog from '@/hooks/ui/use-dialog.hook'
import usePopoverConfirm from '@/hooks/ui/use-popover-confirm.hook'

const UiFeedbackComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})
  const { popoverConfirm, handleClosePopoverConfirm } = usePopoverConfirm()

  const { dialog } = useDialog()

  return (
    <>
      <PopoverConfirmComponent
        {...popoverConfirm}
        handleClosePopoverConfirm={handleClosePopoverConfirm}
      />
      {dialog.feedback?.formStatus !== undefined && (
        <DialogFeedbackComponent
          open={dialog.open && dialog.id === 'DIALOG_FEEDBACK'}
          id={dialog.id}
          feedback={dialog.feedback}
        />
      )}
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
    </>
  )
}

export default UiFeedbackComponent
